import { render } from "./hero.vue?vue&type=template&id=698e1401&scoped=true"
import script from "./hero.vue?vue&type=script&lang=js"
export * from "./hero.vue?vue&type=script&lang=js"

import "./hero.vue?vue&type=style&index=0&id=698e1401&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-698e1401"

export default script